import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {AutoScraperBackendService} from "../auto-scraper-backend.service";
import {environment} from "../../environments/environment";
import {catchError} from "rxjs/operators";
import {EMPTY} from "rxjs";
import {SupplierImplementationWithPageSource} from "../model";


@Component({
    selector: 'app-test-implementation-component',
    templateUrl: './test-implementation.component.html',
    styleUrls: ['./test-implementation.component.css'],
    standalone: false
})
export class TestImplementationComponent {
  constructor(private http: HttpClient, public data: AutoScraperBackendService) {
  }

  page_source: string = ""
  response: any = null;
  status: string = ""



  /**
   * Returns which step produced a field's value, as the backend reports it in `sources`
   * ('css#2' = second step of the chain, a CSS selector), or '' when the field was not extracted by a chain.
   */
  source(field: string): string {
    const source: string | null | undefined = this.response?.sources?.[field];
    if (source === undefined) return '';
    if (source === null) return 'nothing found';
    const [kind, position] = source.split('#');
    const labels: Record<string, string> = {static: 'static value', fallback: 'fallback value', css: 'CSS', xpath: 'XPath', schema: 'schema'};
    return position ? `step ${position}: ${labels[kind] ?? kind}` : (labels[kind] ?? kind);
  }

  /** Returns the parsed price, or the name of the status a negative price stands for. */
  priceLabel(price: number | null | undefined): string {
    if (price === null || price === undefined) return '';
    const statuses: Record<number, string> = {[-1]: 'client protection', [-2]: 'price on request', [-3]: 'used', [-4]: 'login', [-99]: 'unparseable'};
    return price < 0 ? (statuses[price] ?? String(price)) : String(price);
  }

  /** Attaches page_source to the implementation, POSTs to /test_direct_hit_implementation, and stores the extraction result. */
  extractData() {
    this.status = ""

    let supplier_implementation_with_page_source =
      this.data.supplier_implementation as SupplierImplementationWithPageSource
    supplier_implementation_with_page_source.page_source = this.page_source

    const headers = new HttpHeaders({
      'auth': this.data.token
    });

    this.http.post(environment.apiUrl + "/test_direct_hit_implementation", supplier_implementation_with_page_source, {headers}).pipe(
      catchError((error) => {
        this.status = "Error"
        return EMPTY
      })
    )
      .subscribe((res) => {
        if (typeof res === "string") {
          this.status = res
          return
        }
        else {
          this.status = "Done"
        }

        this.response = res

      });
  }


}
